import Image from "react-bootstrap/Image";
import styled from "styled-components";

const Logo = styled(Image)`
  max-width: 100%;
  max-height: 100%;
`;

export const Loading = () => (
  <div className="d-flex justify-content-center vw-100 vh-100 align-items-center">
    <div>
      <Logo src="/checkout/logo.png" />
      <p className="mt-4">Carregando...</p>
    </div>
  </div>
);

export default Loading;
